import React from 'react'
import {Grid} from '@mui/material';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles'
import vastraLogo from "../../images/vastraLogo.png"
import vastraLogo_2 from "../../images/vastraLogo_2.png"



const useStyles = makeStyles({
    header : {
        width : "100%" , 
        height : "80px" , 
        backgroundImage: "linear-gradient(to right, #8BC43E, #009444)" , 
        direction : "rtl" , 
        display : "flex" , 
        alignItems : "center"
    } ,
    logoSection : {
        display : "flex" , 
        alignItems : "center"
    } ,
    persianLogo : {
        height : "80px" , 
        marginRight : "24px"
    } ,
    englishLogo : {
        height : "60px" , 
        marginRight : "36px"
    } ,
    menuSection : {
        display : "flex" , 
        justifyContent : "space-between" , 
        alignItems : "center"
    } , 
});

export default function Header() {

    const classes = useStyles();

    const menuTexts = {
        color : "white" , 
        fontFamily : "Vazir" , 
        fontSize : "16px" , 
        fontWeight : 700
    }

    return (
        <div className={classes.header}>
            <Grid container spacing={2}>
                <Grid item xl={2} lg={2} md={2} sm={2} xs={2} className={classes.logoSection}>
                    <img src={vastraLogo} className={classes.persianLogo}/>
                </Grid>
                <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={4} className={classes.menuSection}>
                    <Typography sx={menuTexts} >شبکه همکاران</Typography>
                    <Typography sx={menuTexts}>خدمات نوآورانه مالی</Typography>
                    <Typography sx={menuTexts}>ارتباط با ما</Typography>
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={2} xs={2} className={classes.logoSection}>
                    <img src={vastraLogo_2} className={classes.englishLogo}/>
                </Grid>
            </Grid>
        </div>
    )
}